'use client';
import * as React from 'react';
import { motion, useAnimation } from 'framer-motion';

interface IconProps {
	isHovered: boolean;
}

export function DeleteIcon({ isHovered }: IconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	const springTransition = {
		type: 'spring',
		stiffness: 500,
		damping: 30,
	};

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<motion.svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<motion.g
					variants={{
						normal: { y: 0 },
						animate: { y: -1.1 },
					}}
					animate={controls}
					transition={springTransition}
				>
					<path d='M3 6h18' />
					<path d='M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2' />
				</motion.g>
				<motion.path
					d='M19 8v12c0 1-1 2-2 2H7c-1 0-2-1-2-2V8'
					variants={{
						normal: { d: 'M19 8v12c0 1-1 2-2 2H7c-1 0-2-1-2-2V8' },
						animate: { d: 'M19 9v12c0 1-1 2-2 2H7c-1 0-2-1-2-2V9' },
					}}
					animate={controls}
					transition={springTransition}
				/>
				<motion.line
					x1='10'
					x2='10'
					y1='11'
					y2='17'
					variants={{
						normal: { y1: 11, y2: 17 },
						animate: { y1: 11.5, y2: 17.5 },
					}}
					animate={controls}
					transition={springTransition}
				/>
				<motion.line
					x1='14'
					x2='14'
					y1='11'
					y2='17'
					variants={{
						normal: { y1: 11, y2: 17 },
						animate: { y1: 11.5, y2: 17.5 },
					}}
					animate={controls}
					transition={springTransition}
				/>
			</motion.svg>
		</div>
	);
} 